/**
 * Dashboard REST API (backdashboard): REACT_APP_API_URL, e.g. http://localhost:3002
 * Optional alias: REACT_APP_DASHBOARD_AUTH_URL (same meaning).
 * Dev fallback: http://localhost:3002 if neither is set.
 */
function dashboardApiBase() {
  const raw = (process.env.REACT_APP_API_URL || process.env.REACT_APP_DASHBOARD_AUTH_URL || '').trim();
  const base = raw.replace(/\/$/, '');
  if (base) return base;
  if (process.env.NODE_ENV === 'development') return 'http://localhost:3002';
  return '';
}

export function dashboardAuthUrl(path) {
  const base = dashboardApiBase();
  const p = path.startsWith('/') ? path : `/${path}`;
  if (!base) return p;
  return `${base}${p}`;
}

const AUTH_SERVER_HINT =
  'Set REACT_APP_API_URL to your backdashboard base URL (e.g. http://localhost:3002) and ensure the API is running.';

/**
 * Parse JSON body and throw a clear Error when status is not OK (handles 502/HTML).
 */
export async function fetchAuthJson(res) {
  const text = await res.text();
  let data = {};
  try {
    if (text) data = JSON.parse(text);
  } catch {
    if (!res.ok) {
      if (res.status === 502 || res.status === 504) {
        throw new Error(`Cannot reach the dashboard API. ${AUTH_SERVER_HINT}`);
      }
      throw new Error(
        `Dashboard API returned an invalid response (${res.status}). ${AUTH_SERVER_HINT}`
      );
    }
    throw new Error('Invalid response from dashboard API.');
  }

  if (!res.ok) {
    if (data.error) throw new Error(data.error);
    if (res.status === 502 || res.status === 504) {
      throw new Error(`Cannot reach the dashboard API. ${AUTH_SERVER_HINT}`);
    }
    if (res.status >= 500) {
      throw new Error(
        `Server error (${res.status}). Check backdashboard: PostgreSQL must be running and DB_* in backdashboard/.env must match your database.`
      );
    }
    throw new Error(`Request failed (${res.status}).`);
  }

  return data;
}
